// src/logging/maskSensitiveText.ts
//
// Reine Funktion, bewusst ohne Imports aus src/server (wie errorLogData.ts und
// maskEmail.ts), damit src/logging unabhaengig und ohne pino/env testbar bleibt.

// E-Mail-Adressen in Freitext. Bewusst konservativ (kein Unicode-Local-Part):
// die Fehlermeldungen der Codebasis nutzen normalisierte Adressen. Alle
// Quantoren sind nach oben begrenzt und der Punkt gehoert fest zur
// Label-Gruppe — der Ausdruck kann auf keiner Eingabe exponentiell
// backtracken (die Texte kommen teils aus Client-Variablen).
const EMAIL_REGEX = /[\w.%+-]{1,64}@(?:[A-Za-z0-9-]{1,63}\.){1,8}[A-Za-z]{2,24}/g;

// IBAN in Freitext, kompakt ("DE05123456789012345678") oder in Vierergruppen
// ("DE89 3704 0044 0532 0130 00"). Der Rest-Alternativzweig deckt die Gruppen ab;
// ohne ihn wuerde nur der erste Block getroffen und die restlichen Stellen blieben
// im Klartext stehen.
const IBAN_REGEX = /\b[A-Z]{2}[0-9]{2}(?:[A-Z0-9]{11,30}|(?:[ ][A-Z0-9]{4}){2,7}(?:[ ][A-Z0-9]{1,4})?)\b/g;

export function maskSensitiveText(value: string): string;
export function maskSensitiveText(value: unknown): unknown;
/**
 * Maskiert PII-Muster in freiem Text (Fehlermeldungen, Stacktraces, Freitext-
 * Feldern): E-Mail-Adressen und IBANs.
 *
 * Gegenstueck zur schluesselbasierten Maskierung in `maskSensitiveVariables`:
 * dort ist der Feldname bekannt, hier nicht — z.B. bei
 * `No user found with email (max@example.com)`.
 *
 * Nicht-Strings werden unveraendert durchgereicht, damit die Funktion in
 * Serializer-/Rekursions-Pfaden ohne Typpruefung nutzbar ist.
 */
export function maskSensitiveText(value: unknown): unknown {
    if (typeof value !== "string") {
        return value;
    }
    if (value.length === 0) {
        return value;
    }

    // Node 14: kein String.prototype.replaceAll — globales Regex + replace.
    return value
        .replace(EMAIL_REGEX, "[redacted-email]")
        .replace(IBAN_REGEX, "[redacted-iban]");
}

/**
 * Maskiert den Meldungsteil eines Stacktraces (alles vor dem ersten `at`-Frame).
 * Die Message steht im Stack noch einmal im Klartext — bei mehrzeiligen Messages
 * (z.B. TypeORM-QueryFailedError mit eingebettetem SQL) ueber mehrere Zeilen.
 * Die Frames selbst (Dateipfade) bleiben unangetastet.
 */
export function maskStackTraceMessage(stack: string): string {
    const frameStart = /\n\s+at /.exec(stack);
    const cut = frameStart ? frameStart.index : stack.length;

    return maskSensitiveText(stack.slice(0, cut)) + stack.slice(cut);
}
